import * as R from 'ramda';
import sportsApi from '../../utils/sportsApi';

const createCollections = store => async (state, payload) => {
    const userClientId = state.user.selectedUserClientId;
    const clientId = state.user.selectedClientId;
    const newCollection = await sportsApi
        .url(`/clients/${clientId}/collections`)
        .json(payload)
        .post()
        .badRequest(e => {
            throw e;
        })
        .json();

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        collections: {
                            list: {
                                items: R.assocPath(
                                    [newCollection.id],
                                    newCollection,
                                ),
                            },
                        },
                        filters: {
                            collections: {
                                list: R.assocPath(
                                    [newCollection.id],
                                    newCollection,
                                ),
                            },
                        },
                    },
                },
            },
            store.getState(),
        ),
        true,
    );
};

export default createCollections;
